/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 旗舰店导航栏列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ColumnDetail>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/shop-navigation`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
